import { consoleRequest } from '@/console/api/http'
import { DefaultPriorityGridRequest, DefaultPriorityGridResponse } from '@/console/api/types'

/**
 * LOGISPRD-15812 — 디폴트 센터 우선순위 일괄 반영(moms-be LOGISPRD-12117, FF `feature.defaultPriorityGrid`).
 * 인가는 화주 범위 검사(`@RequireShipperScope(WRITE)`)다. 서비스 토큰 경로는 prd 에서 화주가 Unresolved 로 떨어져 403 이라
 * 운영 반영은 이 화면처럼 Okta 세션으로 부른다.
 *
 * 요청 본문을 그대로 싣고 응답도 그대로 돌려준다. 입력 검증은 `tabs/obs/defaultPriorityGrid.ts` 가 맡는다.
 * 슬롯 최종 상태 덮어쓰기라 같은 본문을 다시 보내도 결과가 같지만, 자동 재시도는 하지 않는다.
 */
const SET_DEFAULT_PRIORITY_GRID_URL = '/api/v1/set-default-priority-grid'

export const requestSetDefaultPriorityGrid = (request: DefaultPriorityGridRequest): Promise<DefaultPriorityGridResponse> =>
  consoleRequest.post<DefaultPriorityGridResponse, DefaultPriorityGridRequest>(SET_DEFAULT_PRIORITY_GRID_URL, request)
